// extracted by mini-css-extract-plugin
export default {"card":"ReviewCard_card__nsIrP","meta":"ReviewCard_meta__Adci9","author":"ReviewCard_author__XXVD-","when":"ReviewCard_when__CeoKC","text":"ReviewCard_text__wj3V+"};